



























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class PlaceWorkingHours extends Vue {
    @Prop() workingHours!: any;

}
